import { memo } from 'react';
import classNames from 'classnames';
import { isNil } from 'lodash';
import { useTranslation, type TFunction } from 'react-i18next';
// Import Types
import type { DataTableColumn } from 'types';
// Import Components
import DataTable from 'components/common/DataTable';
// Import Styles
import styles from './playersDataTable.module.scss';

export interface PlayersDataTableProps {
    name?: React.ReactNode;
    data?: Nullable<{ Data: AnyObject[] }>;
    isLoading?: boolean;
    TitleActions?: React.ReactNode;
    config: (t: TFunction) => { columns: DataTableColumn[] };
}

const PlayersDataTable: React.FC<PlayersDataTableProps> = (props) => {
    const { name, data, isLoading = true, TitleActions, config } = props;
    const { t } = useTranslation();
    const columns = config(t).columns.map((item, index) => ({
        ...item,
        index: index,
    }));

    const mapRows = () => {
        const tmpRows = data?.Data?.map((elem, index) => ({
            index,
            actionBar: false,
            dragDisable: true,
            hasHover: true,
            data: columns.reduce(
                (accumulator, element) => {
                    accumulator[element.dataKey ?? ''] = elem[element.dataKey ?? ''];
                    return accumulator;
                },
                { index },
            ),
        }));
        return isNil(tmpRows) ? [] : tmpRows;
    };

    return (
        <DataTable
            classNames={classNames(styles.table, { [styles.onlyTable]: !TitleActions })}
            name={name ?? ''}
            columnKey="dataKey"
            rowKey="index"
            data={mapRows()}
            dataCount={mapRows().length}
            columns={columns}
            isLoading={isLoading}
            isVisibleOnlyDataTable={!TitleActions}
            withPagination={false}
            withPageSelector={false}
            TitleActions={TitleActions}
        />
    );
};

export default memo(PlayersDataTable);
